import type { TFunction } from 'i18next';
import { useFormik } from 'formik';
import { errorToastMessage } from '../../components/layout/toast-root/toast';
import { getForgotPasswordFormValidation } from './FormikData';
import { FirebaseErrorCodes } from '../../shared/constants';
import { useFirebaseAuth } from '../../hooks/useFirebaseAuth';

export function useForgotPasswordPage(t: TFunction, afterSinnIn: () => void) {
  const { resetPassword } = useFirebaseAuth();

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getForgotPasswordFormValidation(t),
    initialValues: { email: '' },
    onSubmit,
  });

  async function onSubmit(values: { email: string }) {
    try {
      await resetPassword(values.email);

      afterSinnIn();
    } catch (error: any) {
      console.error('Register error message: ', error);
      if (FirebaseErrorCodes.includes(error.code)) {
        errorToastMessage(t(`error.${error.code}`));

        return;
      }
      errorToastMessage(t('error.somethingWentWrong'));
    }
  }

  return { formik };
}
